import { addItem, removeItem } from '../../../utils/common';

function deepCopy(obj) {
  return JSON.parse(JSON.stringify(obj));
}

export const parent2FileConversionBuilder = ({
  foldersTree,
  conversionData,
  movedRes,
  convertedParentToFile,
  isDeleteEvent = false,
  convertedFolderId = undefined,
}) => {
  let foldersList = deepCopy(foldersTree);

  if (isDeleteEvent) {
    foldersList = removeItem(foldersList, movedRes?.id);
  } else if (movedRes && !isDeleteEvent) {
    const { data, draft, markdown_data, is_draft_published, ...movedData } = movedRes;
    foldersList = addItem(removeItem(foldersList, movedData?.id), movedData);
  }
  if (convertedParentToFile && conversionData) {
    const { is_parent_folder, ...convertedData } = conversionData;
    if (is_parent_folder) {
      foldersList = addItem(removeItem(foldersList, convertedData?.id), convertedData);
    } else {
      if (convertedFolderId) foldersList = removeItem(foldersList, convertedFolderId);
      const itemsNotInWorkspace = convertedData?.children?.filter((item) => {
        return !foldersList?.find((folder) => folder?.id === item?.id);
      });
      foldersList = [...foldersList, ...itemsNotInWorkspace];
    }

    if (isDeleteEvent && movedRes?.id) foldersList = removeItem(foldersList, movedRes?.id);
    else if (movedRes?.id) foldersList = addItem(foldersList, movedRes);
    const { children, ...parentData } = convertedData;
    return { foldersList, isParentFolder: is_parent_folder, parentInfo: parentData };
  }
  return { foldersList };
};

export default parent2FileConversionBuilder;
